export default __webpack_public_path__ + "static/media/mirchaye.1b0f0e2f.png";